import { render, staticRenderFns } from "./ShopEditor.vue?vue&type=template&id=c610291c&scoped=true"
import script from "./ShopEditor.vue?vue&type=script&lang=ts"
export * from "./ShopEditor.vue?vue&type=script&lang=ts"
import style0 from "./ShopEditor.vue?vue&type=style&index=0&id=c610291c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c610291c",
  null
  
)

export default component.exports